import { h } from 'vue'
import OrganismCompaniesTrust from '~/components/organisms/companies-trust/companies-trust.vue'
import UiComponentContainer from '~ui/components/container/container.vue'

const Functional = (props) => {
  return h(UiComponentContainer, { class: 'customers' }, () => [
    h(OrganismCompaniesTrust, {
      companies: props.record.customers
        .filter(customer => customer.logoColor?.url)
        .slice(0, props.clientWidth < 768 ? 4 : 5)
        .map(customer => ({
          alt: customer.logoColor?.alt,
          height: customer.logoColor?.height,
          url: customer.logoColor?.url,
          width: customer.logoColor?.width,
        })),
      forPersonalization: props.record.forPersonalization,
      type: props.page.chiliPiperCalendarUrl
        ? 'chilipiper-form'
        : 'modal-form',
    }, {
      experience: () =>
        props.record.forPersonalization ? props.record.yourCompanyText : undefined,
      heading: () =>
        props.markdown.render(props.record.text || ''),
    }),
  ])
}

Functional.props = {
  markdown: {
    required: true,
    type: Object,
  },
  page: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
